import React from 'react';
import { Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import './theme/custom.css';
import './theme/global.css';
/* Theme variables */
import './theme/variables.css';
import MainPage from './pages/MainPage';
import { coreApp } from './cvp-webgames-core/App/CoreApp';
import { CoreBaseApiSimulationStatus } from './cvp-webgames-core/Api/Endpoint/CoreBaseApiSimulationEndpoint';
import { gameAPI } from './api/GameAPI';
import Tools from './cvp-webgames-core/Misc/Tools';
import { CustomGameSingleScenario, PageType } from './misc/tools';

coreApp.init(() => {
	if(!localStorage.getItem('status-set-bs')) {
		gameAPI.simulation.setStatus(CoreBaseApiSimulationStatus.InProgress).then(() => {
			localStorage.setItem('status-set-bs', CoreBaseApiSimulationStatus.InProgress.toString())
		});
	}
});

document.getElementsByTagName('html')[0].classList.add(Tools.isios() ? 'html-ios' : 'html-desktop');

Tools.init(([
	{
		scenarioWindow: PageType.Scenario1,
		isLocked: false,
		isCompleted: false,
		score: 0,
		maxScore: 4,
		CurrentQuestion: 0,
		MaxQuestions: 4,
		area: -1,
		aarEntries: [],
		isComingSoon: false
	}, {
		scenarioWindow: PageType.Scenario2,
		isLocked: false,
		isCompleted: false,
		score: 0,
		maxScore: 4,
		CurrentQuestion: 0,
		MaxQuestions: 4,
		area: -1,
		aarEntries: [],
		isComingSoon: false
	}, {
		scenarioWindow: PageType.Scenario3,
		isLocked: false,
		isCompleted: false,
		score: 0,
		maxScore: 4,
		CurrentQuestion: 0,
		MaxQuestions: 4,
		area: -1,
		aarEntries: [],
		isComingSoon: false
	}, {
		scenarioWindow: PageType.Scenario4,
		isLocked: false,
		isCompleted: false,
		score: 0,
		maxScore: 4,
		CurrentQuestion: 0,
		MaxQuestions: 4,
		area: -1,
		aarEntries: [],
		isComingSoon: false
	}, {
		scenarioWindow: PageType.Scenario5,
		isLocked: false,
		isCompleted: false,
		score: 0,
		maxScore: 4,
		CurrentQuestion: 0,
		MaxQuestions: 4,
		area: -1,
		aarEntries: [],
		isComingSoon: false
	}]) as CustomGameSingleScenario[])

const App: React.FC = () => (
	<IonApp style={{
		cursor: 'url("./assets/images/general/icons/mouse-idle.png"), auto'
	}}>
		<IonReactRouter>
			<IonRouterOutlet>
				{/* <Route path={process.env.PUBLIC_URL} component={MainPage} exact={true} /> */}
				<MainPage></MainPage>
			</IonRouterOutlet>
		</IonReactRouter>
	</IonApp>
);

export default App;
